import React from "react";

import "./sponsored-tag.m.css";

const sponsoredTag = () => {
  return <div styleName="wrapper">ಇದು ಪ್ರಾಯೋಜಿತ ಲೇಖನ ಸರಣಿಯ ಭಾಗ.</div>;
};

export default sponsoredTag;
